<template>
  <div class="home">
      <HeroSection />
      <ByTheNumbersSection id="by-the-numbers" />
      <HowItWorksSection id="how-it-works" />
      <TechStackSection id="tech-stack" />
      <ClientsSection />
      <ServicesSection id="services" />
      <ProjectGallerySection id="project-gallery" />
      <CaseStudiesSection id="case-studies" />
      <MethodologySection id="methodology" />
      <AboutSection id="about" />
      <TeamSection id="team" />
      <LegalSafetyWidget />
      <BlogFeed id="blog" />
      <TrustFooterSection id="trust" />
      <ContactSection id="contact" />
      <ImprintSection id="imprint" />
  </div>
</template>

<script setup>
import HeroSection from '@/components/HeroSection.vue'
import ByTheNumbersSection from '@/components/ByTheNumbersSection.vue'
import HowItWorksSection from '@/components/HowItWorksSection.vue'
import TechStackSection from '@/components/TechStackSection.vue'
import ClientsSection from '@/components/ClientsSection.vue'
import ServicesSection from '@/components/ServicesSection.vue'
import ProjectGallerySection from '@/components/ProjectGallerySection.vue'
import CaseStudiesSection from '@/components/CaseStudiesSection.vue'
import MethodologySection from '@/components/MethodologySection.vue'
import AboutSection from '@/components/AboutSection.vue'
import TeamSection from '@/components/TeamSection.vue'
import LegalSafetyWidget from '@/components/LegalSafetyWidget.vue'
import BlogFeed from '@/components/BlogFeed.vue'
import TrustFooterSection from '@/components/TrustFooterSection.vue'
import ContactSection from '@/components/ContactSection.vue'
import ImprintSection from '@/components/ImprintSection.vue'
</script>
